<template>
  <span>En cours...</span>
</template>

<script>
export default {
  name: 'UserList',
};
</script>

<style scoped>

</style>
